<template>
  <div class="goods">
    <Header :navIndex="navIndex"></Header>
    <div class="wrap">
      <!-- banner -->
      <!-- v-mouseenter="index" -->

      <div class="banner">
        <div
          v-for="(item, index) in banner"
          :key="index"
          @mouseover="bannerChoose(index, item.id)"
          :class="active == index ? 'active' : 'normal'"
        >
          <img :src="active == index ? item.hover_image : item.image" alt="" />
        </div>
      </div>

      <!-- 左右箭头横向列表 -->
      <div class="chooseWrap">
        <div class="arrow arrowLft" @click="last" v-if="active == 0">
          <img src="../assets/goods/right.png" alt="" />
        </div>

        <div class="inset" ref="box">
          <div
            @mouseover="chooseTab(index, item.id)"
            :class="windowsIndex == index ? 'chooseActive' : 'chooseNormal'"
            v-for="(item, index) in sonlist"
            :key="index"
            style="white-space: pre-wrap"
          >
            <div>{{ item.models }}</div>
            <div>{{ item.title }}</div>
          </div>
        </div>

        <div class="arrow arrowRight" @click="next" v-if="active == 0">
          <img src="../assets/goods/left.png" alt="" />
        </div>
      </div>

      <!-- 下面文字段落 -->
      <div class="intro">
        <div class="descWrap">
          <div class="left">
            <img class="line" src="../assets/index/line.png" alt="" />
            <div class="title">{{ title }}</div>
            <div class="subTitle">{{ desc }}</div>
            <div class="pic">
              <div class="picLeft">
                <div class="picTop">
                  <div class="picTitle">{{ pictitle }}</div>
                  <div class="picEn">{{ picen }}</div>
                </div>
                <div class="picBtm">
                  <div class="picDesc" v-html="picdesc"></div>
                </div>
              </div>
              <div class="picRight">
                <img :src="`${image}`" alt="" />
              </div>
            </div>
            <!-- 产品功能介绍 -->
            <div class="titleImg">
              <img src="../assets/goods/adver.png" alt="" />
            </div>
            <div class="advert">{{ advantage }}</div>

            <!-- 可选木色 -->
            <div class="titleImg">
              <img src="../assets/goods/kxms.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- 可选木色 -->
      <div>
        <!-- pc -->
        <div v-if="!this.$isMobile" class="msWrap">
          <div class="ms">
            <div
              ref="wood"
              class="littleCircle"
              v-for="(item, index) in mutoulist"
              :key="index"
              :class="value === index ? 'bigWood' : ''"
            >
              <img
                :src="
                  value === index ? item.wood_images : item.wood_small_images
                "
                alt=""
              />
            </div>
          </div>
          <div class="slider" v-if="!this.$isMobile">
            <div class="block">
              <el-slider
                :min="0"
                :max="mutounum"
                v-model="value"
                active-color="#004c31"
                :show-tooltip="false"
                @input="chooseWoods"
              ></el-slider>
            </div>
          </div>
        </div>
        <!-- 移动 -->
        <div v-else class="msWrap">
          <div class="ms">
            <div
              class="bigWood"
              v-for="(item, index) in mutoulist"
              :key="index"
            >
              <img :src="item.wood_images" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- 可选吕色标题 -->
      <div class="intro">
        <div class="descWrap">
          <div class="left">
            <div class="titleImg">
              <img src="../assets/goods/lv.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- 可选吕色 -->
      <div>
        <!-- pc -->
        <div v-if="!this.$isMobile" class="msWrap" style="margin-bottom: 100px">
          <div class="ls">
            <div
              ref="lv"
              class="littleCircle"
              v-for="(item, index) in lvlist"
              :key="index"
              :class="lvValue === index ? 'bigWood' : ''"
            >
              <!-- <img :src="item" alt="" /> -->
              <img
                :src="
                  lvValue === index
                    ? item.aluminium_images
                    : item.aluminium_small_images
                "
                alt=""
              />
            </div>
          </div>
          <div class="slider" v-if="!this.$isMobile">
            <div class="block">
              <el-slider
                :min="0"
                :max="lvnum"
                v-model="lvValue"
                active-color="#004c31"
                :show-tooltip="false"
                @input="chooseLv"
              ></el-slider>
            </div>
          </div>
        </div>
        <!-- 移动 -->
        <div v-else class="msWrap" style="margin-bottom: 100px">
          <div class="ls" style="overflow-x: unset">
            <div
              ref="lv"
              class="bigWood"
              v-for="(item, index) in lvlist"
              :key="index"
            >
              <img :src="item.aluminium_images" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <XFK></XFK>
    <Part5></Part5>
  </div>
</template>

<script>
import Header from "../components/Header";
import XFK from "../components/XFK";
import Part5 from "../components/Part5.vue";
import {
  goodsBanner,
  getGoodsTitleByCateId,
  getGoodsByGoodsId,
} from "../api/request";
export default {
  // 自定义组件
  directives: {
    hClick: {
      inserted(el, binding, index) {
        // console.log(el);
        // console.log(binding);
        // console.log(index);
        if (binding.value === 0) {
          el.click();

          // 给for循环第一个元素执行点击事件
        }
      },
    },
    aClick: {
      inserted(el, binding, index) {
        // console.log(el);
        // console.log(binding);
        // console.log(index);
        if (binding.value === 0) {
          el.click();

          // 给for循环第一个元素执行点击事件
        }
      },
    },
  },
  name: "goods",
  // , Part5, XFK
  components: { Header, XFK, Part5 },
  data() {
    return {
      value: 0,
      lvValue: 0,
      // 主轮播图
      banner: [],

      // 子系列
      sonlist: [],

      // 子系列的当前项
      windowsIndex: 0,
      // windowsData: [
      //   {
      //     title: "GR-86爱家系列",
      //     desc: "内敛端庄，持重大气",
      //     advert:
      //       "GR-86爱家系列是一款以木材为主要受力构件的铝包木窗产品，采用工程塑料将外铝卡到木材结构的窗体上，铝材壁厚1.5mm。主要起装饰作用及防腐作用，使得门窗更为安全可靠。外铝为无缝焊接。本产品为内开窗，用于建筑的外围护结构。\n",
      //     pic: {
      //       title: "铝包木内开窗",
      //       en: "Aluminum-clad interior window",
      //       desc: [
      //         "·铝包木系列经典款",
      //         "·国内顶级标准配置",
      //         "·标准德国铝包木窗节点",
      //       ],
      //       url: require("../assets/goods/cxl1.png"),
      //     },
      //   },
      // ],

      navIndex: 3,
      active: 0,
      title: "",
      image: null,
      desc: "",
      picen: "",
      pictitle: "",
      picdesc: "",
      advantage: "",
      mutoulist: [],
      lvlist: [],
      bannerid: null,
      num: 0,
      mutounum: 0,
      lvnum: 0,
    };
  },
  mounted() {
    // console.log(this.$route.params);
    if (this.$route.params.active) {
      this.active = this.$route.params.active;
    }
    // 请求产品介绍(主图)
    goodsBanner().then((res) => {
      if (res.data.code == 1) {
        this.bannerChoose(0, res.data.data.data[0].category.id);
        // console.log(res.data.data.data);
        this.banner = res.data.data.data.map((item) => {
          return item.category;
        });
      }
    });
    // this.sonlist = localStorage.getItem("sonlist");
    // this.listdetail = localStorage.getItem("listdetail");
  },
  methods: {
    // 主轮播图
    bannerChoose(index, id) {
      console.log(id);
      this.active = index;
      this.windowsIndex = 0;
      // 请求子系列
      getGoodsTitleByCateId({ id: id }).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data);
          // localStorage.setItem("sonlist", this.sonlist);
          // this.sonlist = localStorage.getItem("sonlist");
          this.sonlist = res.data.data;
          this.chooseTab(0, this.sonlist[0].id);

          this.num = res.data.data.length - 1;
        }
      });
    },

    // 选择子系列
    chooseTab(index, id) {
      this.windowsIndex = index;
      // console.log(index);
      // 子系列的id
      // console.log(id);

      getGoodsByGoodsId({ id: id }).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data);
          var obj = res.data.data;

          this.title = obj.title;
          this.image = obj.image;
          this.image = obj.image;
          this.desc = obj.desc;
          this.pictitle = obj.pictitle;
          this.picen = obj.picen;
          this.picdesc = obj.picdesc;
          this.advantage = obj.advantage;

          // 取可选木色
          this.mutounum = res.data.data.wood_image.length - 1;
          // console.log(this.mutounum);

          this.mutoulist = obj.wood_image;
          // console.log(this.mutoulist);
          // console.log(a);

          this.lvlist = obj.aluminium_image;
          // console.log(this.lvlist);
          this.lvnum = res.data.data.aluminium_image.length - 1;
        }
      });

      // 当前点击元素的左边距离
      const distanceL = document
        .getElementsByClassName("chooseActive")[0]
        .getBoundingClientRect().left;
      // 点击元素的一半宽度
      const elementHW =
        document.getElementsByClassName("chooseActive")[0].clientWidth;
      // 屏幕宽度
      const screenW = document.body.clientWidth;
      // 屏幕宽度的一半
      const screenHW = document.body.clientWidth / 2;
      // 元素右边距离
      const distanceR = screenW - distanceL;
      // 获取最外层的元素
      const scrollBox = document.getElementsByClassName("inset");
      // 滚动条滚动的距离
      const scrollL = scrollBox[0].scrollLeft;
      // 当元素左边距离大于屏幕一半宽度  或者  右边距离大于屏幕一半距离的时候
      if (
        distanceL > screenHW - elementHW ||
        distanceR > screenHW - elementHW
      ) {
        // 滚动条最终的滚动距离
        scrollBox[0].scrollLeft = scrollL + (distanceL - screenHW + elementHW);
      }
    },

    // 左箭头
    last() {
      if (this.windowsIndex > 0) {
        this.chooseTab(this.windowsIndex - 1);
      }
    },
    // 右箭头
    next() {
      if (this.windowsIndex < this.num) {
        this.chooseTab(this.windowsIndex + 1);
      }
    },

    // 吕
    chooseLv(val) {
      console.log(val);
      this.lvValue = val;

      const scrollBox = document.getElementsByClassName("ls");

      if (this.$isMobile) {
        scrollBox[0].scrollLeft =
          (this.$refs.lv[val].clientWidth / 2 + 10) * val;
      } else {
        if (val != this.lvnum) {
          scrollBox[0].scrollLeft =
            (this.$refs.lv[val].clientWidth / 2 + 21) * val;
        } else {
          scrollBox[0].scrollLeft = 1400;
        }
      }
      // console.log(this.$refs.lv);
      // 滚动条滚动的距离
      // const scrollL = scrollBox[0].scrollLeft
      // 当元素左边距离大于屏幕一半宽度  或者  右边距离大于屏幕一半距离的时候
      // if (distanceL > (screenHW - elementHW) || distanceR > (screenHW - elementHW)) {
      // 滚动条最终的滚动距离
      // console.log();

      // scrollBox[0].scrollLeft = (this.$refs.lv[val].clientWidth/2+20)*val
      // }
    },
    // 木材
    chooseWoods(val) {
      this.value = val;
      // console.log(val);
      // this.woodindex = index
      // 当前点击元素的左边距离
      // const distanceL = document.getElementsByClassName('chooseActive')[0].getBoundingClientRect().left
      // // 点击元素的一半宽度
      // const elementHW = document.getElementsByClassName('chooseActive')[0].clientWidth
      // // 屏幕宽度
      // const screenW = document.body.clientWidth
      // // 屏幕宽度的一半
      // const screenHW = document.body.clientWidth / 2
      // // 元素右边距离
      // const distanceR = screenW - distanceL
      // 获取最外层的元素
      const scrollBox = document.getElementsByClassName("ms");
      // console.log(this.$refs.wood);
      // 滚动条滚动的距离
      // const scrollL = scrollBox[0].scrollLeft
      // 当元素左边距离大于屏幕一半宽度  或者  右边距离大于屏幕一半距离的时候
      // if (distanceL > (screenHW - elementHW) || distanceR > (screenHW - elementHW)) {
      // 滚动条最终的滚动距离
      // console.log();
      if (this.$isMobile) {
        scrollBox[0].scrollLeft =
          (this.$refs.wood[val].clientWidth / 2 + 10) * val;
      } else {
        if (val != this.mutounum) {
          scrollBox[0].scrollLeft =
            (this.$refs.wood[val].clientWidth / 2 + 21) * val;
        } else {
          scrollBox[0].scrollLeft = 1400;
        }
      }
      // }
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  font-family: 微软雅黑, MicrosoftYaHei;
  .banner {
    width: 1483px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .normal {
      width: 318px;
      height: 600px;
      img {
        width: 318px;
        height: 600px;
      }
    }
    .active {
      width: 529px;
      transition: width 1s;
      img {
        width: 529px;
        height: 600px;
      }
    }
  }
  // 新
  // .chooseWrap {
  //   width: 100%;
  //   height: 90px;
  //   // border: 1px solid blue;
  //   background: #f1f1f1;
  //   font-size: 20px;
  //   color: #6c7a77;
  //   padding: 1px;
  //   display: flex;
  //   align-items: center;
  //   // justify-content: center;
  //   position: relative;
  //   .arrow {
  //     position: absolute;
  //     width: 15px;
  //     height: 22px;
  //     cursor: pointer;
  //   }
  //   .arrowLft {
  //     left: 280px;
  //   }
  //   .arrowRight {
  //     left: 1630px;
  //   }
  //   .inset {
  //     width: 1280px;
  //     height: 90px;
  //     margin: 0 auto;
  //     display: flex;
  //     flex-wrap: nowrap;
  //     overflow-x: scroll;
  //     overflow-y: hidden; /* 超出内容不可见 */
  //     white-space: nowrap; /* 不换行 */
  //     // align-items: center;
  //     // 当前点击
  //     .chooseActive {
  //       cursor: pointer;
  //       width: 240px;
  //       height: 90px;
  //       background: #004c31;
  //       color: #ffffff;
  //       border-radius: 500px;
  //       text-align: center;
  //       display: flex;
  //       align-items: center;
  //       justify-content: center;
  //       font-weight: bold;
  //       margin: 0px 50px 0;
  //       flex-shrink: 0;
  //     }
  //     // 不点击
  //     .chooseNormal {
  //       flex-shrink: 0;
  //       border: 1px solid #fff;
  //       cursor: pointer;
  //       width: 165px;
  //       // width: 100%;
  //       // height: 165px;
  //       height: 100%;
  //       display: flex;
  //       align-items: center;
  //       justify-content: center;
  //       margin: 0px 17px 0;
  //     }
  //   }
  //   .insert::-webkit-scrollbar {
  //     display: none;
  //   }
  // }
  // 旧
  .chooseWrap {
    width: 100%;
    height: 90px;
    background: #f1f1f1;
    font-size: 20px;
    color: #6c7a77;
    padding: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .arrow {
      position: absolute;
      width: 15px;
      height: 22px;
      cursor: pointer;
    }
    .arrowLft {
      left: 280px;
    }
    .arrowRight {
      left: 1630px;
    }
    .inset {
      overflow-x: scroll;
      width: 1280px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .chooseActive {
        cursor: pointer;
        width: 240px;
        height: 90px;
        background: #004c31;
        color: #ffffff;
        border-radius: 500px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        margin: 0px 50px 0;
        flex-shrink: 0;
      }
      .chooseNormal {
        flex-shrink: 0;
        cursor: pointer;
        width: 165px;
        height: 165px;
        display: flex;
        flex-direction: column;

        align-items: center;
        justify-content: center;
        margin: 0px 17px 0;
      }
    }
  }
  .intro {
    padding: 85px 0;
    margin-top: -5px;
    .descWrap {
      width: 1280px;
      margin: 0 auto;
      .left {
        text-align: left;
      }
      .line {
        width: 90px;
        height: 8px;
      }
      .title {
        font-size: 42px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38px;
      }
      .subTitle {
        margin-top: 24px;
        font-size: 24px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
      .pic {
        margin: 32px auto 0;
        width: 1280px;
        height: 450px;
        background: #f5f5f5;
        padding: 1px;
        display: flex;
        justify-content: space-between;
        .picLeft {
          width: 394px;
          margin: 60px 0 0 60px;
          .picTop {
            border-bottom: 1px dotted #ccc;
            .picTitle {
              font-size: 24px;
              font-weight: bold;
              color: #004c31;
            }
            .picEn {
              font-size: 20px;
              color: #004c31;
              margin: 14px 0 22px 0;
            }
          }
        }
        .picBtm {
          margin-top: 20px;
        }
        .picDesc {
          font-size: 20px;
          color: #6c7a77;
          list-style: circle;
          margin-top: 12px;
        }
        .picRight {
          width: 750px;
          height: 450px;
          img {
            width: 750px;
            height: 450px;
          }
        }
      }
      .titleImg {
        width: 238px;
        height: 45px;
        margin-top: 99px;
        img {
          width: 238px;
          height: 45px;
        }
      }
      .advert {
        margin-top: 32px;
        font-size: 20px;
        color: #6c7a77;
      }
    }
  }
  .msWrap {
    width: 100%;
    height: 247px;
    background: #f1f1f1;
    padding: 1px;
    .ms,
    .ls {
      width: 1280px;
      margin: 20px auto 0;
      overflow-x: scroll;
      display: flex;
      align-items: center;
      .bigWood {
        margin: 20px;
        width: 158px !important;
        height: 158px !important;
        /*transform: scale(1.2);*/
        img {
          width: 158px !important;
          height: 158px !important;
          /*transform: scale(1.2);*/
        }
      }
      .littleCircle {
        margin: 20px;
        width: 89px;
        height: 89px;
        img {
          width: 89px;
          height: 89px;
        }
      }
    }
    .slider {
      width: 1160px;
      margin: 8px auto 0;
      .custom-button {
        width: 43px;
        height: 43px;
        background: url("../assets/process/yearActive.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.van-slider::before {
  position: absolute;
  top: 0rem;
  right: 0;
  bottom: -0.5rem;
  left: 0;
  height: 0.1rem;
  border: 1px solid #004c31;
  border-radius: 20px;
  content: "";
}
/deep/.el-slider__runway {
  background: unset;
  border: 1px solid #004c31;
}
/deep/.el-slider__bar {
  background: #004c31 !important;
}
/deep/.el-slider__button {
  border: none;
  background: unset;
}
/deep/.el-slider__button-wrapper {
  width: 43px;
  height: 43px;
  background: url("../assets/process/yearActive.png");
  background-size: 100% 100%;
}
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 5=0px;
}
::-webkit-scrollbar-track {
  //轨道部分
  border-radius: 0px;
}
@media screen and (max-width: 450px) {
  .wrap {
    font-family: 微软雅黑, MicrosoftYaHei;
    .banner {
      width: 1483px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .normal {
        width: 318px;
        height: 600px;
        img {
          width: 318px;
          height: 600px;
        }
      }
      .active {
        width: 529px;
        transition: width 1s;
        img {
          width: 529px;
          height: 600px;
        }
      }
    }

    .chooseWrap {
      width: 100%;
      height: 90 * 2px;
      background: #f1f1f1;
      font-size: 20 * 2px;
      color: #6c7a77;
      padding: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .arrow {
        position: absolute;
        width: 15 * 2px;
        height: 22 * 2px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .arrowLft {
        left: 280px;
      }
      .arrowRight {
        left: 1630px;
      }
      .inset {
        overflow-x: scroll;
        width: 1280px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        .chooseActive {
          cursor: pointer;
          width: 270 * 2px;
          height: 90 * 2px;
          background: #004c31;
          color: #ffffff;
          border-radius: 500px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          margin: 0px 50px 0;
          flex-shrink: 0;
        }
        .chooseNormal {
          flex-shrink: 0;
          cursor: pointer;
          width: 260 * 2px;
          height: 90 * 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0px 17px 0;
        }
      }
    }
    .intro {
      padding: 85px 0;
      margin-top: -5px;
      .descWrap {
        width: 1580px;
        margin: 0 auto;
        .left {
          text-align: left;
        }
        .line {
          width: 90 * 2px;
          height: 8 * 2px;
        }
        .title {
          font-size: 42 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: bold;
          color: #004c31;
          margin-top: 38 * 2px;
        }
        .subTitle {
          margin-top: 24 * 2px;
          font-size: 24 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #004c31;
        }
        .pic {
          margin: 32px auto 0;
          width: 1580px;
          height: auto;
          background: #f5f5f5;
          padding: 1px;
          display: flex;
          justify-content: space-between;
          .picLeft {
            width: 394 * 2px;
            margin: 60px 0 0 60px;
            .picTop {
              border-bottom: 1px dotted #ccc;
              .picTitle {
                font-size: 24 * 2px;
                font-weight: bold;
                color: #004c31;
              }
              .picEn {
                font-size: 20 * 2px;
                color: #004c31;
                margin: 14px 0 22px 0;
              }
            }
          }
          .picBtm {
            margin-top: 20px;
          }
          .picDesc {
            font-size: 20px;
            color: #6c7a77;
            list-style: circle;
            margin-top: 12px;
          }
          .picRight {
            width: 750px;
            height: 450px;
            img {
              width: 750px;
              height: 450px;
            }
          }
        }
        .titleImg {
          width: 238 * 2px;
          height: 45 * 2px;
          margin-top: 99px;
          img {
            width: 238 * 2px;
            height: 45 * 2px;
          }
        }
        .advert {
          margin-top: 32px;
          font-size: 20 * 2px;
          color: #6c7a77;
        }
      }
    }
    .msWrap {
      width: 100%;
      height: auto;
      background: #f1f1f1;
      padding: 1px;
      .ms,
      .ls {
        width: 1400px;
        margin: 60px auto 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .bigWood {
          margin: 20px;
          width: 158px !important;
          height: 158px !important;
          /*transform: scale(1.2);*/
          img {
            width: 158px !important;
            height: 158px !important;
            /*transform: scale(1.2);*/
          }
        }
        .littleCircle {
          margin: 20px;
          width: 89px;
          height: 89px;
          img {
            width: 89px;
            height: 89px;
          }
        }
      }
      .slider {
        width: 1160px;
        margin: 38px auto 0;
        .custom-button {
          width: 43px;
          height: 43px;
          background: url("../assets/process/yearActive.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
